import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

type Gtag = (command: "event", name: string, params: Record<string, string>) => void;

/**
 * GA4 counts the first page view itself (the tag is injected by the server in production); this
 * reports client-side navigations after that. A no-op when gtag is absent (dev, blockers).
 */
export function usePageView(): void {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const gtag = (window as Window & { gtag?: Gtag }).gtag;
    gtag?.("event", "page_view", {
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}
